import { getData } from "./index";


export const getDashboardData = async (payload) => {
  return getData("admin/getDashboardData", payload).then((data) => {
    return data;
  });
};

